/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="17"
        viewBox="0 0 19 17"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M17.45 5.22h-2.06V1.41c0-.78-.6-1.41-1.38-1.41H4.64c-.78 0-1.41.63-1.41 1.41v3.81H1.17C.52 5.22 0 5.77 0 6.39v8.5c0 .65.55 1.17 1.17 1.17h16.3c.65 0 1.17-.55 1.17-1.17V6.42c0-.65-.55-1.2-1.2-1.2ZM4.17 1.41c0-.26.21-.5.5-.5h9.34c.26 0 .5.21.5.5v8.17H4.17V1.41Zm13.57 13.51c0 .16-.1.26-.26.26H1.17c-.16 0-.26-.1-.26-.26v-8.5c0-.16.1-.26.26-.26h2.06v4.36h11.92c.1 0 .23-.1.23-.23V6.14h2.06c.16 0 .26.1.26.26v8.53h.03Z"
          style={{ fill: '#4a4a4a' }}
          className="icon-fill"/>
        <path
          d="M13.33 2.53H5.32v.91h8.01v-.91ZM13.33 4.77H5.32v.91h8.01v-.91ZM13.33 7.02H5.32v.91h8.01v-.91Z"
          style={{ fill: '#4a4a4a' }}
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'FaxIcon';

export default Icon;
